import {
  ChannelTypeInternal,
  SensorChannelStateResponse,
  SensorChannelStateResponseFragment,
  SensorTypeInternal,
  UserChannel,
} from '../../../../../data-access/gql-types/graphql';
import { ChannelIconTypeEnum } from '../../../../../types';
import { ChannelType } from '../../../types';
import { ChannelSensorStateType } from '../../../types/channel/sensor';

export const parseSensorChannel = (userChannel: UserChannel): ChannelType => {
  const channelPayload = userChannel.payload as SensorChannelStateResponse | undefined;

  return {
    id: userChannel.id,
    installationId: userChannel.installationId,
    isVisible: userChannel.isVisible,
    alias: userChannel.alias,
    iconName: userChannel.iconName || ChannelIconTypeEnum.SENSOR,
    deviceId: userChannel.deviceId,
    currentFirmwareVersion: userChannel.currentFirmwareVersion || null,
    data: {
      type: ChannelTypeInternal.Sensor,
      groupType: ChannelTypeInternal.Sensor,
      sensorType: channelPayload?.sensorType || SensorTypeInternal.Unknown,
      unit: channelPayload?.unit,
    },
  };
};

export const parseSensorChannelState = (userChannel: UserChannel): ChannelSensorStateType => {
  const channelPayload = userChannel.payload as
    | (SensorChannelStateResponse & SensorChannelStateResponseFragment)
    | undefined;

  return {
    deviceConnectionState: channelPayload?.deviceConnectionState,
    value: channelPayload?.sensorValue,
  };
};
